import styled from '@emotion/styled'
import React, { type FC, type PropsWithChildren } from 'react'

const StyledPageContainer = styled.div`
  padding: 20px 30px;
`

const StyledLayoutContainer = styled.div`
  min-width: 730px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  margin: 0 auto;
`

type PageContainerProps = PropsWithChildren<{
  className?: string
}>

const PageContainer: FC<PageContainerProps> = ({ children, className }) => {
  return (
    <StyledPageContainer className={className}>
      <StyledLayoutContainer>{children}</StyledLayoutContainer>
    </StyledPageContainer>
  )
}

export default PageContainer
